import { useLocation, useNavigate } from "react-router-dom";
import { useSmoothScroll } from "./smoothScroll";

export const useSectionNav = () => {
  const { scrollTo } = useSmoothScroll();
  const navigate = useNavigate();
  const location = useLocation();

  return (hash: string) => {
    if (location.pathname !== "/") {
      navigate({ pathname: "/", hash });
    } else {
      scrollTo(hash);
    }
  };
};
